export default __webpack_public_path__ + "static/media/ic_time.977e8a07.svg";